import gql from 'graphql-tag'

export const ADD_INTERIOR_SELECTION = gql`
  mutation AddInteriorSelection(
    $clientName: String!
    $input: InteriorSelectionInput!
  ) {
    addInteriorSelection(clientName: $clientName, input: $input)
  }
`

export const GET_INTERIOR_SELECTION = gql`
  query GetInteriorSelection($clientName: String!, $id: UUID!) {
    getInteriorSelection(clientName: $clientName, id: $id) {
      json
    }
  }
`
